import { render } from "./DashboardFleetTripOverview.vue?vue&type=template&id=52817c71"
import script from "./DashboardFleetTripOverview.vue?vue&type=script&lang=js"
export * from "./DashboardFleetTripOverview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__